/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddReplyCommandResult } from '../../models/add-reply-command-result';

export interface ApiKpiReportsAddReplyPost$Plain$Params {
      body?: {
'NoteId'?: string;
'ParentId'?: string;
'Notes'?: string;
'Lat'?: number;
'Lng'?: number;
'IsDuplicated'?: boolean;
'ImageRate'?: number;
'Attachments'?: Array<Blob>;
}
}

export function apiKpiReportsAddReplyPost$Plain(http: HttpClient, rootUrl: string, params?: ApiKpiReportsAddReplyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddReplyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsAddReplyPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddReplyCommandResult>;
    })
  );
}

apiKpiReportsAddReplyPost$Plain.PATH = '/api/KPIReports/AddReply';
